/**
 * WE-115: Session Replay is deferred until the user grants analytics
 * consent (see src/components/ClientWrapper/ConsentBanner) — it records
 * user sessions (potential PII) and must not start before consent.
 *
 * Lives in its own module (not in src/instrumentation-client.ts, even
 * though that's where Sentry.init() runs) so importing it — e.g. from a
 * UI component — only pulls in `@sentry/nextjs`'s addIntegration/
 * replayIntegration, not the whole Sentry.init side effect.
 */
import * as Sentry from '@sentry/nextjs';

let replayEnabled = false;

export function enableSentryReplay(): void {
    if (replayEnabled) return;
    replayEnabled = true;
    Sentry.addIntegration(Sentry.replayIntegration());
}
